<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <form class="row" v-on:submit.prevent="submitExcelFile">
                <div class="col-md-4">
                    <label>انتخاب فایل مناسبت ها</label>
                    <div class="input-group file-browser">
                        <input type="text" class="form-control border-left-0 browse-file" id="events-calendar" placeholder="آپلود فایل" readonly="">
                        <label class="input-group-btn mb-0">
                            <span class="btn btn-primary">
                                انتخاب کنید <input type="file" style="display: none;" accept=".xlsx" @input="setExcelFile">
                            </span>
                        </label>
                    </div>
                    <p class="mt-3 mb-0">
                        <a href="#" @click="e => getExcelSample(e)">دریافت فایل نمونه</a>
                    </p>
                </div>
                <div class="col-md-12" v-if="file">
                    <button class="btn btn-success mt-3">ثبت اطلاعات</button>
                </div>
            </form>
            <div class="row mt-2" v-if="events.length">
                <div class="col-md-12">
                    <hr>
                    <h5 class="mt-4 mb-4">مناسبت های ملی / مذهبی ثبت شده</h5>
                    <ul v-if="events.length" class="mb-0">
                        <li v-for="(event,index) in events" class="mb-2" :key="index">{{ event.date.slice(0,4) + '-' + event.date.slice(4,6) + '-' + event.date.slice(6,8) }} - {{ event.title }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Calendar',
    data(){
        return {
            showLoading: false,
            file: '',
            events: []
        }
    },
    methods: {
        getData(){
            this.showLoading = true;
            const postedData = {
                eventType: [
                    1
                ],
                all: true
            };
            this.$api.post('Organizations/GetEvents',postedData).then(({data}) => {
                if(data.result.result)
                    this.events = data.result.result;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('events-calendar').setAttribute('placeholder',file.name);
        },
        submitExcelFile(){
            this.showLoading = true;
            const postedData = {
                file: this.file
            };
            this.$api.post('Organizations/PublicEvent',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'مناسبت ها با موفقیت بارگذاری شدند',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.file = '';
                    document.getElementById('events-calendar').setAttribute('placeholder','آپلود فایل');
                    this.getData();
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'آپلود فایل ناموفق بود',
                        confirmButtonText: 'متوجه شدم'
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getExcelSample(e){
            e.preventDefault();
            this.$api.get('Organizations/Events/Sheet/Sample').then(({data}) => {
                let csvString = data.result;
                let universalBOM = '\uFEFF';
                let a = window.document.createElement('a');
                a.setAttribute('href','data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
                let fileName = 'events.csv';
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            })
        }
    },
    created(){
        this.getData();
    }
}
</script>